import { render, staticRenderFns } from "./SpotRoleAggregationWidget.global.vue?vue&type=template&id=312d7420&scoped=true&lang=pug&"
import script from "./SpotRoleAggregationWidget.global.vue?vue&type=script&lang=ts&"
export * from "./SpotRoleAggregationWidget.global.vue?vue&type=script&lang=ts&"
import style0 from "./SpotRoleAggregationWidget.global.vue?vue&type=style&index=0&id=312d7420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d7420",
  null
  
)

export default component.exports